var map = {
	"./black-scissors.png": 1328,
	"./blue-scissors.png": 4626,
	"./brown-scissors.png": 4232,
	"./darkwhite-scissors.png": 9679,
	"./green-scissors.png": 1442,
	"./lightbrown-scissors.png": 6025,
	"./white-scissors.png": 2148,
	"./yellow-scissors.png": 7929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4624;